export default "__VITE_ASSET__38350b72__"